import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import submenu from './module/submenu.js'
import scrollMarkers from './module/scrollMarkers.js'
import cursor from './module/cursor.js'
import { initTextClipAnimations, clipBox, initHeroSequentialText } from './module/gsap.js'
import modal from './module/modal.js'
import cookies from './module/cookies.js'
import darkModeOS from './module/darkModeOS.js'
import animations from './module/animations.js'
import contactForm from './module/contactForm.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
import customRellax from './module/customRellax.js';
import transitions from './module/transitions.js';
import accordion from './module/accordion.js';
import marquee from './module/marquee.js';
// import swiperTestimonios from './module/swiperTestimonios.js'; // Se eliminó porque lo incluimos en home-scripts.php
// import swiperSlider from './module/swiperSlider.js';
import tabs from './module/tabs.js';
import hoverActive from './module/hoverActive.js';
// import { CountUp } from './module/countUp.min.js'; // Se eliminó porque lo incluimos en home-scripts.php
// import counterIncrement from './module/counterIncrement.js'; // Se eliminó porque lo incluimos en home-scripts.php
import getDevice from './module/getDevice.js';
import videoIframeLazyLoad from './module/videoIframeLazyLoad.js';
// import typeformLazyLoad from './module/typeformLazyLoad.js';
import goTo, { scrollToHash } from './module/goTo.js';

// Función para inicializar módulos específicos de cada página
const initPageModules = (deviceData) => {
  const page = deviceData.page;

  if (page === 'home') {
    initHeroSequentialText();
    marquee();
    // swiperTestimonios();
    tabs();
    hoverActive(deviceData);
    // counterIncrement(CountUp);
  }

  if (page === 'porque-ihouse') {
    accordion(true);
  }

  if (page === 'proyectos') {
    tabs();
    hoverActive(deviceData);
    // counterIncrement(CountUp);
    // swiperSlider();
  }

  // if (page === 'single-proyectos') {
  //   swiperSlider();
  // }

  // if (page === 'disenos-de-catalogo') {
  //   swiperSlider();
  // }

  // NOTA: La página 'customizer' está excluida de transiciones (ver transitions.js)
  // Su inicialización se maneja en inc/footer/customizer-scripts.php

}

/**
 * Módulos que se vinculan al DOM del transition-wrapper y deben re-ejecutarse
 * en cada navegación. Su teardown lo gestiona el registro de cleanup.
 * @param {object} deviceData
 */
const initPageScopedModules = (deviceData) => {
  lenisScroll()
  scrollMarkers(deviceData)
  menuMobile(deviceData)
  submenu(deviceData)
  cursor()
  animations()
  modal()
  contactForm()
  initTextClipAnimations()
  clipBox()
  customRellax()
  videoIframeLazyLoad()
  // typeformLazyLoad()

  initPageModules(deviceData)
}

// Listener global para re-inicialización después de transiciones
let transitionListenerAdded = false;

function functions (deviceData) {
  // console.log(deviceData);
  darkModeOS(cookies)
  transitions()

  initPageScopedModules(deviceData)

  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)

  // Carga directa con hash / ?go= (sin transición previa)
  goTo()

  // Agregar listener solo una vez
  if (!transitionListenerAdded) {
    window.addEventListener('page-transition-complete', (event) => {
      // console.log('Re-inicializando módulos...');

      // Refrescar el objeto compartido EN SITIO. header/footer/body son nodos
      // nuevos tras el reemplazo del wrapper: si no se actualizan, los módulos
      // siguen apuntando a nodos detached (y el marcador de scroll se rompe).
      Object.assign(deviceData, getDevice(), {
        page: document.body.dataset.page
      })

      initPageScopedModules(deviceData)

      // Tras resetear Lenis a 0, ir al ancla si la URL destino lo pedía
      const hash = event.detail?.hash || location.hash
      if (hash) {
        scrollToHash(hash, { delay: 150 })
      } else {
        goTo({ delay: 150 })
      }
    })
    transitionListenerAdded = true;
  }
}

export default functions
